import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { SiteLayout } from "../home/SiteLayout";
import { PageHero } from "../home/components/PageHero";
import { LEGAL_DOCUMENTS } from "./documents";
import { useSiteTranslation } from "../home/i18n";
import "./legal-page.css";

/** Policy page in the new design: title band, a sidebar of every policy, and the document. */
export function LegalPage({ path, children }) {
  const doc = LEGAL_DOCUMENTS.find((item) => item.path === path);
  const { t, language } = useSiteTranslation();
  const label = t(`legal.docs.${doc.key}.label`);
  const updated = t(`legal.docs.${doc.key}.updated`, { defaultValue: "" });
  const navRef = useRef(null);

  // On small screens the policy list is a horizontal row of chips; bring the current one into view.
  useEffect(() => {
    const nav = navRef.current;
    const active = nav?.querySelector("a.active");
    if (nav && active && nav.scrollWidth > nav.clientWidth) {
      const offset = active.getBoundingClientRect().left - nav.getBoundingClientRect().left;
      nav.scrollLeft += offset - (nav.clientWidth - active.offsetWidth) / 2;
    }
  }, [path]);

  return (
    <SiteLayout title={`${label} — MJMarry`}>
      <PageHero
        eyebrow={t("legal.eyebrow")}
        title={label}
        lead={t(`legal.docs.${doc.key}.lead`)}
        meta={updated ? t("legal.updated", { date: updated }) : null}
      />
      <section className="legal-section">
        <div className="wrap legal-layout">
          <aside className="legal-nav" aria-label={t("legal.policies")}>
            <h2>{t("legal.policies")}</h2>
            <nav ref={navRef}>
              {LEGAL_DOCUMENTS.filter((item) => !item.hidden).map((item) => (
                <NavLink key={item.path} to={item.path}>
                  {t(`legal.docs.${item.key}.label`)}
                </NavLink>
              ))}
            </nav>
            <p>
              {t("legal.questions")} <a href="mailto:support@mjmarry.com" dir="ltr">support@mjmarry.com</a>
            </p>
          </aside>
          {/* The documents are only written in English, so they stay left-to-right. */}
          <article className="legal-doc" dir="ltr" lang="en">
            {language !== "en" && (
              <p className="legal-notice" dir="auto" lang={language}>
                {t("legal.englishOnly")}
              </p>
            )}
            {children}
          </article>
        </div>
      </section>
    </SiteLayout>
  );
}
